import axios from 'axios';
import qs from 'qs';
import Request from './request';

export default {
  // 登录
  login: (params, success, fail) => {
    const data = qs.stringify(params);
    axios
      .request({
        data,
        baseURL: '',
        params: null,
        method: 'post',
        url: '/login',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          // 'Content-Type': 'application/x-www-form-urlencoded'
        },
        withCredentials: true,
        responseType: 'json',
      })
      .then((response) => {
        if (response.data) {
          if (typeof success === 'function') {
            success(response.data);
          }
        }
      })
      .catch((error) => {
        fail(error);
      });
  },

  // 登出
  logout: (success, fail) => {
    axios
      .post('/passport/logout')
      .then(response => success(response.data))
      .catch(error => fail(error));
  },

  // 获取短信验证码
  getMessageCode(phone, params, success) {
    Request.POST(`/sms/sendPhoneCode?phone=${phone}`, params, response =>
      success(response),
    );
  },

  // 重置密码
  resetPassword(params, success, fail) {
    Request.POST(
      '/reset',
      params,
      response => success(response),
      response => fail(response),
    );
  },
};



// WEBPACK FOOTER //
// ./src/api/index.js